// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"table_tableWrapper__kNYUH","table":"table_table__VWWKx","tableSticky":"table_tableSticky__Yduww","emptyTable":"table_emptyTable__1o2md"};